const initialState = {
    config_years: [],
    config_facultyBankAccounts: [],
};
import { getField, updateField } from 'vuex-map-fields';
import ConfigProvider from '../services/config.provider'
const configService = new ConfigProvider()

export const officerConfig = {
    namespaced: true,
    state: initialState,
    actions: {
        async getYears({ commit }) {
            const data = await configService.getYears();
            commit('set_years', data);
        },
        async getFacultyBankAccounts({ commit }) {
            const data = await configService.getFacultyBankAccounts();
            commit('set_facultyBankAccounts', data);
        },
    },
    getters: {
        getField,
    },
    mutations: {
        updateField,
        set_years(state, data) { state.config_years = data },
        set_facultyBankAccounts(state, data) { state.config_facultyBankAccounts = data },
    },
};